import React from 'react'
import InstanceMessage_TopLevel from '../component/InstanceMessage/InstanceMessage_TopLevel'
import HeaderMenu from '../component/Navbar/headermenu'
import CustomFooter from '../component/Footer/customFooter'
import InteractiveDemo from '../component/InstanceMessage/InteractiveDemo'
import ScheduledMessages from '../component/InstanceMessage/ScheduledMessages'
import Templates from '../component/InstanceMessage/Templates'
import InstanceMessage_Simplifyte_Notes from '../component/InstanceMessage/InstanceMessage_Simplifyte_Notes'

export default function InstanceMessage() {
    return (
        <>
            <HeaderMenu />
            <div>
                <InstanceMessage_TopLevel />
                <InteractiveDemo />
                <ScheduledMessages />
                <Templates />
                <InstanceMessage_Simplifyte_Notes />
            </div>
            <CustomFooter />
        </>
    )
}
